import { createSlice } from "@reduxjs/toolkit";

const messagesSlice = createSlice({
  name: "messages",
  initialState: {
    messages: {},
    loading: false,
    error: null,
  },
  reducers: {
    fetchMessagesRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchMessagesSuccess: (state, action) => {
      const { threadId, messages } = action.payload;
      state.loading = false;
      state.messages[threadId] = messages;
      state.error = null;
    },
    fetchMessagesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearMessages: (state, action) => {
      const threadId = action.payload;
      if (threadId) {
        delete state.messages[threadId];
      } else {
        state.messages = {};
      }
    },
    addMessage: (state, action) => {
      const { threadId, message } = action.payload;
      if (!state.messages[threadId]) {
        state.messages[threadId] = [];
      }
      state.messages[threadId].push(message);
    },
  },
});

export const {
  fetchMessagesRequest,
  fetchMessagesSuccess,
  fetchMessagesFailure,
  clearMessages,
  addMessage,
} = messagesSlice.actions;

export default messagesSlice.reducer;

